import { SignalrService } from 'src/app/shared/services/signalr.service';
import { NotificationMsg, NotificationService } from './../../core/common-services/notification.service';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LanguageService } from 'src/app/shared/services/language.service';
import { UserService } from 'src/app/core/common-services/user.services';
import { SessionTimeoutService } from 'src/app/core/common-services/session-timeout.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'Investor-Web';
  currentSystemLanguage: string = 'en-US';
  style: boolean = false;
  notifications: NotificationMsg[] = [];
  private routerSubscription?: Subscription;

  constructor(
    public router: Router,
    public notificationService: NotificationService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
    private signalrService: SignalrService,
    private userService: UserService,
    private sessionTimeoutService: SessionTimeoutService
  ) { }

  ngOnInit(): void {
    this.notifications = this.notificationService.notifications;
    const lang = this.languageService.currentLanguage ?? 'en';
    this.languageService.setLanguage(lang);
    if (this.userService.isLoggedIn()) {
      this.signalrService.startConnection(this.userService.currentUserCredantials.currentUsedInvestorAccountId);
    }

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.userService.isLoggedIn()) {
          this.sessionTimeoutService.startMonitoring();
        } else {
          this.sessionTimeoutService.stopMonitoring();
        }
      }
    });
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.sessionTimeoutService.stopMonitoring();
  }

  isHome() {
    if (this.router.url.indexOf('/home') > -1) {
      return false;
    }
    else {
      return true;
    }
  }

  isLoggedIn() {
    if (localStorage.getItem("currentUser") != null) {
      return true
    }
    else
      return false
  }

  removeNotification(notifications: NotificationMsg) {
    this.notificationService.removeNotification(notifications);
  }
}
